import React from 'react';
import styled from 'styled-components';
import JSONModal from '@/components/JSONModal';

export default function StatsModal({ json, visible, handleClose }) {
  return (
    <JSONModal
      visible={visible}
      handleClose={handleClose}
      json={json}
      title={<Header>查看机器信息</Header>}
    />
  );
}

const Header = styled.div`
  display: flex;
`;
